import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async readStudentsCredentialCopyStorage(params) {
    try {
      const response = await axios.get('certificates/credentials-copy-storage', {params})
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const {
          total,
          records,
        } = data.data
        return [records, total]
      }
    } catch (e) {
      handleCatch(e)
    }
    return [null, 0]
  },
  async updateCredentialCopyStorage(params){
    try {
      const response = await axios.put(`certificates/credentials-copy-storage/${params.id}`, params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
